module.exports = {"441303001":"淡水街道","441303002":"秋长街道","441303003":"三和街道","441303006":"大亚湾澳头街道","441303007":"大亚湾霞涌街道","441303008":"大亚湾西区街道","441303101":"沙田镇","441303103":"新圩镇","441303104":"镇隆镇","441303108":"永湖镇","441303109":"良井镇","441303110":"平潭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441303.json
// module id = 2146
// module chunks = 0